import { RequireAtLeastOne } from '../../util/util';
import { Invoice } from '../../clients/quipli-service/invoice/invoice';
import { Order } from '../../clients/quipli-service/order/order';
import {
  CheckedPaymentResponse,
  DUBIOUS_GATEWAY_STATUSES,
  Payment,
} from '../../clients/quipli-service/payment/payment';

export type OrderDataParams = RequireAtLeastOne<
  {
    orderId?: number;
    order?: Order;
    invoice?: Invoice;
  },
  'orderId' | 'invoice' | 'order'
>;

export function checkInvoicePaymentStatus(invoice: Invoice): CheckedPaymentResponse {
  const suspicious: Payment[] = [];
  const pending: Payment[] = [];
  invoice.payments
    .filter((_) => _.method == 'Stripe' && !!_.gatewayStatus)
    .forEach((payment) => {
      if (DUBIOUS_GATEWAY_STATUSES.includes(payment.status)) {
        suspicious.push(payment);
      } else if (
        payment.status === 'pending' &&
        !['canceled', 'requires_capture', 'requires_payment_method'].includes(payment.gatewayStatus ?? '')
      ) {
        pending.push(payment);
      }
    });
  return { suspicious, pending };
}
